module.exports = __webpack_public_path__ + "img/open-interest-icon.ba0b9faa.svg";